/**
 * Copy Text in an office's own format: a clean re-creation of their sheet as
 * lines of text — their labels, in their order, row by row.
 *
 *   INSURANCE BREAKDOWN
 *
 *   Date: Sep 15, 2026   Active Family Members: ___
 *   Patients Name: Jessica Seebach
 *   (01204) Basic: 80%   Max: $1,000
 *   Implants: No
 *   ...
 *   Recorded Sep 15, 2026 via ProviderConnect · Smilepass
 *
 * A value goes after its label; an option group ("Yes ___ No ___") becomes its
 * question and the true choice. Unknown is "___", exactly as an empty blank.
 */
import { groupAnswer, optionGroups } from "./layoutFormat";
import { formatValue } from "./formatValue";

export const UNKNOWN = "___";
const GAP = "   ";

function clean(label) {
  return String(label || "").replace(/^[\s/]+/, "").replace(/[\s:$%]+$/, "").trim();
}

function fieldLabel(field) {
  return clean(field.printed_label) || clean(field.question) || field.id;
}

// "Implants: Yes:" with the option "Yes" → "Implants".
function groupLabel(group) {
  const first = group[0];
  const label = clean(first.printed_label);
  const option = clean(first.option_label);
  if (option && label.toLowerCase().endsWith(option.toLowerCase())) {
    const rest = clean(label.slice(0, label.length - option.length));
    if (rest) return rest;
  }
  return clean(first.question) || label || first.id;
}

function groupText(group, values) {
  const answer = groupAnswer(group, values, { text: true });
  if (!answer) return UNKNOWN;
  if (answer.hit) return clean(answer.hit.option_label) || formatValue(answer.hit.mark_value, { format: "text" });
  return answer.text || UNKNOWN;
}

export function renderFormatText(template, values, model) {
  const vals = values || {};
  const fields = (template && template.fields) || [];
  const byId = {};
  fields.forEach((f) => { byId[f.id] = f; });
  const groupOf = {};
  optionGroups(fields).forEach((group) => group.forEach((f) => { groupOf[f.id] = group; }));

  const lines = [String((template && template.title) || "Insurance Breakdown").trim().toUpperCase(), ""];
  ((template && template.rows) || []).forEach((ids) => {
    const said = {};
    const parts = [];
    ids.map((id) => byId[id]).filter(Boolean).forEach((field) => {
      if (said[field.id]) return;
      const group = field.render === "mark" ? groupOf[field.id] : null;
      if (group) {
        group.forEach((f) => { said[f.id] = true; });
        parts.push(`${groupLabel(group)}: ${groupText(group, vals)}`);
        return;
      }
      said[field.id] = true;
      parts.push(`${fieldLabel(field)}: ${formatValue(vals[field.id], field, { text: true }) || UNKNOWN}`);
    });
    if (parts.length) lines.push(parts.join(GAP));
  });

  const provenance = (model && model.provenance) || {};
  if (provenance.date || provenance.sourceLabel) {
    lines.push("");
    lines.push(`Recorded ${provenance.date || "—"} via ${provenance.sourceLabel || "Smilepass"} · Smilepass`);
  }
  return lines.join("\n");
}
